// Mapa nacionalidad -> bandera. Compartido entre RegistroCliente (formulario
// de alta) y HomePage (tarjetas de publicaciones), para que ambos usen
// siempre la misma fuente de datos.
const FLAGS = {
  Albanesa: "/flags/albania.svg",
  Alemana: "/flags/alemania.svg",
  Árabe: "/flags/arabe.svg",
  Argentina: "/flags/argentina.svg",
  Australiana: "/flags/australia.svg",
  Austriaca: "/flags/austria.svg",
  Bangladesí: "/flags/bangladesh.svg",
  Belga: "/flags/belgica.svg",
  Boliviana: "/flags/bolivia.svg",
  Bosnia: "/flags/bosnia.svg",
  Brasileña: "/flags/brasil.svg",
  Búlgara: "/flags/bulgaria.svg",
  Canadiense: "/flags/canada.svg",
  Checa: "/flags/republica-checa.svg",
  Chilena: "/flags/chile.svg",
  China: "/flags/china.svg",
  Colombiana: "/flags/colombia.svg",
  Costarricense: "/flags/costa-rica.svg",
  Croata: "/flags/croacia.svg",
  Cubana: "/flags/cuba.svg",
  Danesa: "/flags/dinamarca.svg",
  Dominicana: "/flags/republica-dominicana.svg",
  Ecuatoriana: "/flags/ecuador.svg",
  Española: "/flags/espana.svg",
  Estadounidense: "/flags/estados-unidos.svg",
  Estonia: "/flags/estonia.svg",
  Filipina: "/flags/filipinas.svg",
  Finlandesa: "/flags/finlandia.svg",
  Francesa: "/flags/francia.svg",
  Griega: "/flags/grecia.svg",
  Guatemalteca: "/flags/guatemala.svg",
  Haitiana: "/flags/haiti.svg",
  Holandesa: "/flags/holanda.svg",
  Hondureña: "/flags/honduras.svg",
  Húngara: "/flags/hungria.svg",
  India: "/flags/india.svg",
  Indonesa: "/flags/indonesia.svg",
  Inglesa: "/flags/inglaterra.svg",
  Irlandesa: "/flags/irlanda.svg",
  Italiana: "/flags/italia.svg",
  Jamaicana: "/flags/jamaica.svg",
  Japonesa: "/flags/japon.svg",
  Keniana: "/flags/kenia.svg",
  Letona: "/flags/letonia.svg",
  Lituana: "/flags/lituania.svg",
  Malaya: "/flags/malasia.svg",
  Maldiva: "/flags/maldivas.svg",
  Marroquí: "/flags/marruecos.svg",
  Mexicana: "/flags/mexico.svg",
  Moldava: "/flags/moldavia.svg",
  Neozelandesa: "/flags/nueva-zelanda.svg",
  Nicaragüense: "/flags/nicaragua.svg",
  Nigeriana: "/flags/nigeria.svg",
  Noruega: "/flags/noruega.svg",
  Pakistaní: "/flags/pakistan.svg",
  Panameña: "/flags/panama.svg",
  Paraguaya: "/flags/paraguay.svg",
  Peruana: "/flags/peru.svg",
  Polaca: "/flags/polonia.svg",
  Portuguesa: "/flags/portugal.svg",
  Rumana: "/flags/rumania.svg",
  Rusa: "/flags/rusia.svg",
  Senegalesa: "/flags/senegal.svg",
  Serbia: "/flags/serbia.svg",
  Singapurense: "/flags/singapur.svg",
  Sudafricana: "/flags/sudafrica.svg",
  Sueca: "/flags/suecia.svg",
  Suiza: "/flags/suiza.svg",
  Tailandesa: "/flags/tailandia.svg",
  Tunecina: "/flags/tunez.svg",
  Turca: "/flags/turquia.svg",
  Ucraniana: "/flags/ucrania.svg",
  Uruguaya: "/flags/uruguay.svg",
  Venezolana: "/flags/venezuela.svg",
  Vietnamita: "/flags/vietnam.svg",
};

export function getFlag(nacionalidad) {
  return FLAGS[nacionalidad] || "";
}
